import StationSelectorController from './selector.controller';
import './selector.css';

const template = require<string>('./selector.html');

const selectorComponent:ng.IComponentOptions = {
  bindings: {
    highlightedStationId: '<',
    onSelectChange: '&',
    onStationHighlightChange: '&',
    isWithMeteostations: '<',
    isDisabled: '=',
    isSelectable: '<',
    isElevated: '<',
    stations: '<',
    isDataTypeSelectingEnabled: '<',
    isStationForecastActive: '<',
    isListCached: '<',
    forecastModelFrequency: '='
  },
  controller: StationSelectorController,
  template
};
export default selectorComponent;



/** WEBPACK FOOTER **
 ** ./app/station/selector/selector.component.ts
 **/